import React, { useState } from 'react';

function ShippingAddressGuid({setContactInformation,contactInformation}) {


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactInformation({
      ...contactInformation,
      [name]: value
    });
  };

  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Contact Person */}
        <div className="flex flex-col w-full sm:w-[45%]">
          <label htmlFor="contactPerson" className="mb-2 font-medium">Location Contact Person: <span style={{ color: "red" }}>*</span></label>
          <input
            id="contactPerson"
            name="contactPerson"
            className="border-2 border-gray-400 p-2 rounded w-full"
            placeholder="Enter contact person name"
            value={contactInformation.contactPerson}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Contact Number */}
        <div className="flex flex-col w-full sm:w-[45%] ml-auto">
          <label htmlFor="contactNumber" className="mb-2 font-medium">Contact Number: <span style={{ color: "red" }}>*</span></label>
          <input
            id="contactNumber"
            name="contactNumber"
            className="border-2 border-gray-300 p-2 rounded w-full"
            placeholder="Enter contact number"
            value={contactInformation.contactNumber}
            onChange={(e) => {
              const input = e.target.value;
              if (/^\d{0,10}$/.test(input)) {
                setContactInformation((prevInfo) => ({
                  ...prevInfo,
                  contactNumber: input
                }));
              }
            }}
            required
          />
        </div>
      </div>
    </div>
  );
}

export default ShippingAddressGuid;
